import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type VerifyTokenUrlQueryVariables = Types.Exact<{
  input: Types.VerifyTokenUrlInput;
}>;

export type VerifyTokenUrlQuery = {
  __typename?: 'Query';
  verifyTokenUrl: {
    __typename?: 'VerifyTokenUrlResponse';
    message: string;
    success: boolean;
  };
};

export const VerifyTokenUrlDocument = gql`
  query VerifyTokenUrl($input: VerifyTokenUrlInput!) {
    verifyTokenUrl(input: $input) {
      message
      success
    }
  }
`;
export function useVerifyTokenUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerifyTokenUrlQuery,
    VerifyTokenUrlQueryVariables
  > &
    (
      | { variables: VerifyTokenUrlQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifyTokenUrlQuery, VerifyTokenUrlQueryVariables>(
    VerifyTokenUrlDocument,
    options,
  );
}
export function useVerifyTokenUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifyTokenUrlQuery,
    VerifyTokenUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifyTokenUrlQuery, VerifyTokenUrlQueryVariables>(
    VerifyTokenUrlDocument,
    options,
  );
}
export function useVerifyTokenUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VerifyTokenUrlQuery,
        VerifyTokenUrlQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    VerifyTokenUrlQuery,
    VerifyTokenUrlQueryVariables
  >(VerifyTokenUrlDocument, options);
}
export type VerifyTokenUrlQueryHookResult = ReturnType<
  typeof useVerifyTokenUrlQuery
>;
export type VerifyTokenUrlLazyQueryHookResult = ReturnType<
  typeof useVerifyTokenUrlLazyQuery
>;
export type VerifyTokenUrlSuspenseQueryHookResult = ReturnType<
  typeof useVerifyTokenUrlSuspenseQuery
>;
export type VerifyTokenUrlQueryResult = Apollo.QueryResult<
  VerifyTokenUrlQuery,
  VerifyTokenUrlQueryVariables
>;
export function refetchVerifyTokenUrlQuery(
  variables: VerifyTokenUrlQueryVariables,
) {
  return { query: VerifyTokenUrlDocument, variables: variables };
}
